export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAHklEQVR42mNgYGD4TyFm+E8uGDVg1IBRA6htACUYALwPSOL98n1aAAAAAElFTkSuQmCC"